


























import {
  Vue, Component, Prop, Emit, Watch,
} from 'vue-property-decorator';
import { IProductInfo } from '../../../shared/models';
import InfoEditor from '@/shared/components/InfoEditor.vue';
import NewForm from '@/shared/components/NewForm.vue';
import { api } from '../../../services/index';
import { IProductRequest } from '@/shared/models/products/index';

@Component({
  name: 'SubActionBar',
})
export default class SubActionBar extends Vue {
  editorOption = {
    errorMessage: 'Đang trong tiến trình chỉnh sửa thông tin sản phẩm khác',
    blankText: 'Chọn sản phẩm bên bảng chính để xem thông tin',
    confirmEdit: 'Sửa sản phẩm',
  };

  @Prop() private productId!: number | null;

  @Prop() private totalProduct!: number;

  private productDetail: IProductInfo | null = null;

  private currentTab = 'summary';

  private isLoading = false;

  private newForm: IProductRequest = {
    name: '',
    price: 0,
    cpu: 0,
    ram: 0,
    storage: 0,
    mt4: 0,
  }

  private isCreating = false;

  private async handleCreateProduct() {
    try {
      this.isCreating = true;
      await this.$api.products.createProduct(this.newForm);
      this.$notify.success('Tạo sản phẩm thành công');
      this.isCreating = false;
      this.$emit('refetch');
    } catch (e) {
      this.$notify.error(`Đã xảy ra lỗi, vui lòng thử lại. ${e}`);
      this.isCreating = false;
    }
  }


  @Emit('clearSelection')
  protected clear() {}

  @Watch('productId', { immediate: true })
  async onProductIdChange(value: any) {
    if (!value) {
      this.productDetail = null;
    } else {
      this.isLoading = true;
      this.currentTab = 'detail';
      this.productDetail = await this.$api.products.getProduct(value);
      this.isLoading = false;
    }
  }

  async handleUpdateProduct(value: any) {
    try {
      await this.$api.products.updateProduct(this.productId, value);
      this.$notify.success(
        `Cập nhật thông tin product ${this.productId} thành công!`,
      );
      this.$emit('refetch');
    } catch (e) {
      this.$notify.error(`Đã xảy ra lỗi: ${e.error}`);
    }
  }
}
